import React from 'react';
import { createContext, useContext, useReducer, useEffect, useState } from "react";
import { apiCall } from '../helpers/api';
import { Modal, Button, Form } from 'react-bootstrap';

export const AuthContext = createContext();

async function getSession() {
  if (process.env.REACT_APP_DISABLE_AUTH == true) {
    return null
  }
  var response = await apiCall("session",{ "method" : "GET" });
  if (response["success"]) {
    return response["success"]["session"]
  } else {
    return null
  }
}

const ACTIONS = {
  LOGIN: "login",
  LOGOUT: "logout"
}

const MFAEnforcement = () => {
  const { data } = useContext(AuthContext);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isOnSettings = window.location.pathname === '/Settings' || window.location.hostname === 'localhost';
    if (data?.currentProfile?.type == "admins" && !isOnSettings) {
      if (data.details?.mfaEnabled == false) {
        setShow(true);
      }
    } else {
      setShow(false);
    }
  }, [data]);

  const handleSubmit = (redirect) => {
    window.location.href = "/Settings?setting=security";
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Please Enable 2FA</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <div>2FA is now mandatory for your account.</div>
          <div>Please enable it by going to your <a onClick={() => handleSubmit(true)}>security settings here</a></div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="button" onClick={() => handleSubmit(true)}>
            Ok
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

const AnnouncementCheck = () => {
  const { data } = useContext(AuthContext);
  const [announcements, setAnnouncements] = useState([]);
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      if (!data) {
        return;
      }
      setLoading(true);
      try {
        const response = await apiCall("announcements", { method: "GET" });
        const announcementsArr = response.announcements || (response.success && response.success.announcements);
        if (announcementsArr && announcementsArr.length > 0) {
          setAnnouncements(announcementsArr);
          setShow(true);
          setCurrent(0);
        } else {
          setShow(false);
        }
      } catch (e) {
        setShow(false);
      }
      setLoading(false);
    };
    fetchAnnouncements();
  }, [data]);

  const markAsRead = async (announcementId) => {
    try {
      await apiCall("announcement/read", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: { announcementId }
      });
    } catch (e) {}
  };

  const handleNext = async () => {
    if (announcements[current]) {
      await markAsRead(announcements[current]._id);
    }
    if (current < announcements.length - 1) {
      setCurrent(current + 1);
    } else {
      setShow(false);
    }
  };

  if (!show || loading || announcements.length === 0) {
    return null;
  }
  const announcement = announcements[current];

  return (
    <Modal show={show} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>{announcement.title}</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <div>{announcement.description}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="button" onClick={handleNext}>
            {current < announcements.length - 1 ? "Next" : "Close"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export const authReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.LOGIN:
      var views = [];
      var defaultID = "";
      for (const memberships in action.payload.memberships){
        if (["brands","influencers"].includes(memberships) && action.payload.memberships[memberships].length > 1){
          views.push(`${memberships}Multiple`)
        }
        views.push(memberships)
      }
      return { data: action.payload, views: views, roles: [], currentProfile: action.payload.currentProfile, session: action.payload }
    case ACTIONS.LOGOUT:
      return { data: action.payload, views: views, roles: [], currentProfile: "", session: "" }
    default:
      return state
  }
}

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    data: null,
    views: [],
    roles: [],
    defaultID: ""
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    var user = null
    const getSessionData = async () => { 
      user = await getSession() 
      
      if (user) {
        dispatch({type: ACTIONS.LOGIN, payload: user})
      }
      setLoading(false)
    }
    
    getSessionData();
  }, [])

  return ( 
  <AuthContext.Provider value={{...state, dispatch, loading}}>
    <MFAEnforcement />
    <AnnouncementCheck />
    { children }
    </AuthContext.Provider>
  )
};

export const useAuth = () => {
  return useContext(AuthContext);
};